import React, { useContext, useState } from 'react';
import { AuthContext } from '../context/AuthContext';
import AdminNotPageFormList from './AdminNotPageFormList';
import AdminOrderList from './AdminOrderList';
import AdminProductList from './AdminProductList';
import AdminSettings from './AdminSettings';
import AdminUserList from './AdminUserList';
import ButtonRegular from './ui/ButtonRegular';
import '../styles/AdminControlPanel.css';

const AdminControlPanel = () => {
	const { logout } = useContext(AuthContext);
	const [activeTab, setActiveTab] = useState('products'); // Domyślna zakładka

	const handleLogout = () => {
		logout();
		window.location.href = '/login'; // Przekierowanie po wylogowaniu
	};

	return (
		<div className="admin-panel">
			{/* Sidebar z menu */}
			<nav className="sidebar">
				<h2>Panel Administratora</h2>
				<ul>
					<li 
						className={activeTab === 'products' ? 'active' : ''}
						onClick={() => setActiveTab('products')}
					>
						📦 Zarządzanie produktami
					</li>
					<li 
						className={activeTab === 'forms' ? 'active' : ''}
						onClick={() => setActiveTab('forms')}
					>
						📄 Formularze
					</li>
					<li 
						className={activeTab === 'orders' ? 'active' : ''}
						onClick={() => setActiveTab('orders')}
					>
						🧾 Zamówienia
					</li>
					<li 
						className={activeTab === 'users' ? 'active' : ''}
						onClick={() => setActiveTab('users')}
					>
						👥 Zarządzanie użytkownikami
					</li>
					<li 
						className={activeTab === 'settings' ? 'active' : ''}
						onClick={() => setActiveTab('settings')}
					>
						⚙️ Zarządzanie kategoriami i kolorami
					</li>
				</ul>
				<ButtonRegular onClick={handleLogout}>🚪 Wyloguj się</ButtonRegular>
			</nav>

			<main className="admin-content">
				{activeTab === 'products' && <AdminProductList />}
				{activeTab === 'forms' && <AdminNotPageFormList />}
				{activeTab === 'orders' && <AdminOrderList />}
				{activeTab === 'users' && <AdminUserList />}
				{activeTab === 'settings' && <AdminSettings />}
			</main>
		</div>
	);
};

export default AdminControlPanel;
